/**
 * Engine furniture: the files every deck carries because the template ships
 * them (the RKH mark, the hummingbird, the jungle artwork, placeholder art),
 * as opposed to the pictures someone chose for THIS deck.
 *
 * Both asset-browsing surfaces hide them, for the same reason: a shelf called
 * "your images" that opens on four files you have never seen reads as a bug,
 * and it is the noise that made the editor's assets panel feel unnavigable.
 * They are hidden, not deleted — slides reference them, and the usage scan
 * will happily report that.
 *
 * Shared rather than copied so the two surfaces cannot drift into disagreeing
 * about what counts as furniture.
 */
export const FURNITURE_RE = /^(logo\.(png|svg)|hummingbird\.png|jungle-artwork\.jpg|placeholder-)/i;

export function isFurniture(name: string): boolean {
  return FURNITURE_RE.test(name);
}
